class CartDrawer extends HTMLElement {
	constructor() {
		super()

		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
		this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
		this.setHeaderCartIconAccessibility()

		document.addEventListener('l:product:added', (event) => {
			const { response } = event.detail

			this.renderContents(response)
			this.classList.remove('is-empty')
		})
	}

	setHeaderCartIconAccessibility() {
		const cartLinks = document.querySelectorAll('#cart-icon-bubble, #cart-icon-bubble-sticky')
		if (!cartLinks.length) return
		cartLinks.forEach((icon) => this.addDrawerOpenHandler(icon))
	}

	addDrawerOpenHandler(icon) {
		if (!icon) return

		icon.setAttribute('role', 'button')
		icon.setAttribute('aria-haspopup', 'dialog')
		icon.addEventListener('click', (event) => {
			event.preventDefault()
			this.open(icon)
		})
		icon.addEventListener('keydown', (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault()
				this.open(icon)
			}
		})
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy)
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote)
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'active')
		})

		this.addEventListener(
			'transitionend',
			() => {
				const containerToTrapFocusOn = document.getElementById('CartDrawer')

				const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')

				trapFocus(containerToTrapFocusOn, focusElement)
			},
			{ once: true }
		)

		document.body.classList.add('overflow-hidden')
	}

	close() {
		this.classList.remove('active')
		removeTrapFocus(this.activeElement)
		document.body.classList.remove('overflow-hidden')

		if (MOUSE_CURSOR) MOUSE_CURSOR.hide()
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button')
		cartDrawerNote.setAttribute('aria-expanded', 'false')

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
		})

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
			this.querySelector('.drawer__inner').classList.remove('is-empty')

		if (parsedState && parsedState.id) {
			this.productId = parsedState.id
		}

		this.getSectionsToRender()?.forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id)

			if (sectionElement && parsedState && parsedState?.sections) {
				sectionElement.innerHTML = this.getSectionInnerHTML(parsedState?.sections[section.id], section.selector)
			}
		})

		setTimeout(() => {
			this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
			this.open()
		})
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
			},
			{
				id: 'cart-icon-bubble-sticky',
			},
		]
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
	}

	setActiveElement(element) {
		this.activeElement = element
	}
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__inner',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-icon-bubble-sticky',
				section: 'cart-icon-bubble-sticky',
				selector: '.shopify-section',
			},
		]
	}
}

customElements.define('cart-drawer-items', CartDrawerItems)

